import gql from "graphql-tag";

export const MutationCreateSetting = gql(`
mutation(
    $id: ID!
    $handSide: String!
    $colorGreen: String
    $colorBlue: String
    $colorPurple: String
    $colorRed: String
    $colorOrange: String
    $colorClear: String
    $assessmentType: String
    $created: String
    $updated: String
) {
    createSetting(input: {
        id: $id
        handSide: $handSide
        colorGreen: $colorGreen
        colorBlue: $colorBlue
        colorPurple: $colorPurple
        colorRed: $colorRed
        colorOrange: $colorOrange
        colorClear: $colorClear
        assessmentType: $assessmentType
        created: $created
        updated: $updated
    }) {
        id
        handSide
        colorGreen
        colorBlue
        colorPurple
        colorRed
        colorOrange
        colorClear
        assessmentType
        created
        updated
    }
}`);

export const MutationUpdateSetting = gql(`
mutation(
    $id: ID!
    $handSide: String!
    $colorGreen: String
    $colorBlue: String
    $colorPurple: String
    $colorRed: String
    $colorOrange: String
    $colorClear: String
    $assessmentType: String
    $updated: String
) {
    updateSetting(input: {
        id: $id
        handSide: $handSide
        colorGreen: $colorGreen
        colorBlue: $colorBlue
        colorPurple: $colorPurple
        colorRed: $colorRed
        colorOrange: $colorOrange
        colorClear: $colorClear
        assessmentType: $assessmentType
        updated: $updated
    }) {
        id
        handSide
        colorGreen
        colorBlue
        colorPurple
        colorRed
        colorOrange
        colorClear
        assessmentType
        created
        updated
    }
}`);

export const QueryGetSetting = gql(`
query($id: ID!) {
    getSetting(id: $id) {
        handSide
        colorGreen
        colorBlue
        colorPurple
        colorRed
        colorOrange
        colorClear
        assessmentType
        created
        updated
    }
}`);
